
export const mutations = {
    STORE_PERMISSIONS(state, perms) {
        state.permissions = perms
    }
}

export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/permissions/mutations.js